import { CmsMeta } from '../cms/cmsMeta';
import SanitizedHtml from '../SanitizedHtml/SanitizedHtml';
import './BrandHeader.css';

type BrandHeaderProps = {
	backgroundUrl: string;
	brandName: string;
	text: string;
	logoUrl?: string;
	heroText?: string;
};

export const BrandHeader = ({ backgroundUrl, logoUrl, heroText, brandName, text }: BrandHeaderProps) => {
	return (
		<div className="kg-brand-header" aria-label="Brand header">
			<div className="kg-brand-header__hero" style={{ backgroundImage: `url(${backgroundUrl})` }}>
				{logoUrl && (
					<div className="kg-brand-header__logo-wrapper">
						<img className="kg-brand-header__logo" src={logoUrl} alt="" />
					</div>
				)}
				{heroText && <h3 className="kg-brand-header__hero-text">{heroText}</h3>}
			</div>

			<div className="kg-brand-header__panel">
				<h3 className="kg-brand-header__heading">{brandName}</h3>
				<SanitizedHtml as="p" html={text} className="kg-brand-header__text" />
			</div>
		</div>
	);
};

export const cmsMeta: CmsMeta = {
	description:
		'The introduction at the top of a brand page, in brands/<name>.json. `brandName` and `backgroundUrl` are both required - without them the heading is empty and the hero asks the browser for url(undefined). The page itself exists only while the catalogue still carries that brand.',
	example: [
		'BrandHeader',
		{
			brandName: 'Nobo',
			backgroundUrl: 'https://cdn.ondio.com/assets/acb2359301574b91932962acc545b6b3.jpg',
			logoUrl: 'https://cdn.ondio.com/assets/af15597bc4a14b32bd089ef060ac4ea0.png',
			text: 'Nobo gør det nemmere at visualisere idéer, lede møder og skabe struktur i det daglige arbejde.',
		},
	],
};
